<div class="chart-container">
   <canvas baseChart width="300" height="300" type="doughnut" [data]="chartData"></canvas>
</div>

